import React from 'react';
import styles from "./index.module.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import FooterImage from './images/footer.png';

let cx = classNames.bind(styles);

const Footer = (props) => (
    <div className={styles.footer}>
        <div className={styles.container}>
            <img src={FooterImage}/>
        </div>
    </div>
);

export default Footer;
